const prescriptions = [
  {
    path: '/express/index',
    name: 'express_index',
    component: () => import( '@/pages/express/index'),
    meta: {keepAlive: true, name: '订单列表'},
  },
  {
    path: '/express/deaddress',
    name: 'express_deaddress',
    component: () => import( '@/pages/express/decaddress'),
    meta: {keepAlive: true, name: '解析地址'},
  },
  {
    path: '/express/repeat',
    name: 'express_repeat',
    component: () => import( '@/pages/express/repeat'),
    meta: {keepAlive: true, name: '订单列表'},
  },
  {
    path: '/express/detail',
    name: 'express_detail',
    component: () => import( '@/pages/express/detail'),
    meta: {keepAlive: true, name: '订单明细'},
  },

]

export default prescriptions



// WEBPACK FOOTER //
// ./src/router/modules/express.js